import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../contexts/PermissionsContext';
import Spinner from './Spinner';

export type PortalModule = 'offboarding' | 'eslSolum' | 'odooImages' | 'onboarding';

interface Props {
  module: PortalModule;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<Props> = ({ module, children }) => {
  const { permissions, isLoading } = usePermissions();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!permissions[module]) {
    return <Navigate to="/access-denied" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
